export default {
  setRango(state, r) {
    state.rango = r;
  },
  setRangoKey(state, payload) {
    state.rango[payload.key] = payload.value
  },
  setRangoHistorialKey(state, payload) {
    state.rangoHistorial[payload.key] = payload.value
  },
  setRangoComparar(state, r) {
    state.rangoComparar = r;

  },
  setRangoCompararKey(state, payload) {
    state.rangoComparar[payload.key] = payload.value
  },
  setTipo(state, tipo) {
    state.tipo = tipo;
  },
  setPedidos(state, p) {
    state.pedidos = p;
  },
  setPedidosHistorial(state, p) {
    state.pedidosHistorial = p;
  },

  setPedidosComparar(state, p) {
    state.pedidosComparar = p;
  },
  setFormaPago(state, f) {
    state.filtrosEleccion.formaPago = f;
  }
}